module.exports = __webpack_public_path__ + "img/icon_service3.622756f4.png";